/** Render an authorized poll projection; vote commands retain server authority. */
export function pollCard(ctx, post) {
  const poll = post.poll;
  const card = ctx.e('section', 'poll-card');
  card.dataset.postRegion = 'poll';
  card.setAttribute('aria-label', 'Poll');
  card.append(ctx.e('h3', '', poll.question));
  poll.options.forEach((label, i) => {
    const percentage = poll.total ? Math.round((poll.counts[i] / poll.total) * 100) : 0;
    const b = ctx.button(
      '',
      () => ctx.command({ type: 'vote', id: post.id, option: i }),
      'poll-option',
    );
    b.append(
      ctx.e('span', '', label),
      ctx.e(
        'span',
        'poll-result',
        `${percentage}% · ${poll.counts[i]}${poll.myVote === i ? ' ✓' : ''}`,
      ),
    );
    b.dataset.focusKey = `post-${post.id}-vote-${i}`;
    b.setAttribute('aria-pressed', String(poll.myVote === i));
    b.disabled = poll.closed;
    card.append(b);
  });
  card.append(
    ctx.e(
      'p',
      'subtle',
      `${poll.total} ${poll.total === 1 ? 'vote' : 'votes'} · ${poll.closed ? 'Voting closed' : 'Closes ' + new Date(poll.closesAt).toLocaleString()}${poll.myVote !== null && !poll.closed ? ' · You can change your vote' : ''}`,
    ),
  );
  return card;
}
